export const calculateMAOP = (designFactor, smys, defaultWallThickness, outsideDiameter) => {
  const df = parseFloat(designFactor) || 0;
  const s = parseFloat(smys) || 0;
  const wt = parseFloat(defaultWallThickness) || 0;
  const od = parseFloat(outsideDiameter) || 1; // avoid division by zero
  return (2 * df * s * wt / od).toFixed(2);
};